import React, { useEffect, useState } from 'react';
import { useCart } from '../context/CartContext';

const Wishlist = () => {
  const [wishlist, setWishlist] = useState([]);

  useEffect(() => {
    const saved = JSON.parse(localStorage.getItem('wishlist')) || [];
    setWishlist(saved);
  }, []);
  const { addToCart } = useCart();
  const [addedIds, setAddedIds] = useState([]);
  
  const removeFromWishlist = (productId) => {
    const updated = wishlist.filter(item => item.productId !== productId);
    setWishlist(updated);
    localStorage.setItem('wishlist', JSON.stringify(updated));
  };

  if (wishlist.length === 0) {
    return <p className="p-6 text-center text-gray-600">Your wishlist is empty 💔</p>;
  }

  return (
    <div className="pt-20 p-6 max-w-6xl mx-auto">
      <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
  {wishlist.map((item) => {
    const outOfStock = item.stock <= 0;
    const isAdded = addedIds.includes(item._id);

    return (
      <div
        key={item.productId}
        className="relative bg-white rounded shadow p-2 hover:shadow-lg transition cursor-pointer"
        onClick={() => window.location.href = `/product/${item.productId}`}
      >
       
        {/* 🛑 Out of Stock badge */}
        {outOfStock && (
          <div className="absolute top-2 right-2 bg-red-600 text-white text-xs px-2 py-1 rounded-full shadow">
            Out of Stock
          </div>
        )}

        {/* 🖼 Product image */}
        {item.photos?.[0] && (
          <img
            src={`/uploads/${item.photos[0].replace(/\\/g, '/')}`}
            alt={item.name}
            className="w-full h-48 object-cover rounded"
          />
        )}

        {/* ❌ Remove from Wishlist button */}
        <div>
        <button
          onClick={(e) => {
            e.stopPropagation();
            removeFromWishlist(item.productId);
          }}
          className="absolute top-2 right-2 bg-red-500 text-white text-xs px-2 py-1 rounded hover:bg-red-600 z-10"
        >
          Remove
        </button> </div>

        {/* 📦 Product info + Add to Cart */}
        <div className="p-2">
          <h3 className="text-base font-semibold truncate">{item.name}</h3>
          <p className="text-sm text-gray-600">Weight: {item.weight}g</p>
          <p className="text-sm text-blue-700 font-semibold">${item.price.toFixed(2)}</p>

          <button
            onClick={(e) => {
              e.stopPropagation();
              if (outOfStock) return;
              if (isAdded) {
                window.location.href = '/cart';
              } else {
                addToCart(item);
                setAddedIds(prev => [...prev, item._id]);
              }
            }}
            disabled={outOfStock}
            className={`mt-2 w-full text-sm py-1 rounded transition-all duration-300 ${
              outOfStock
                ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                : isAdded
                  ? 'bg-green-600 hover:bg-green-700 text-white'
                  : 'bg-blue-600 hover:bg-blue-700 text-white scale-105'
            }`}
          >
            {outOfStock ? 'Out of Stock' : isAdded ? 'Go to Cart' : 'Add to Cart'}
          </button>
        </div>
      </div>
    );
  })}
</div>



    </div>
  );
};

export default Wishlist;
